/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IllegalContentReportViewContainer_story = {
    readonly id: string;
    readonly url: string;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_story">;
    readonly " $refType": "IllegalContentReportViewContainer_story";
};
export type IllegalContentReportViewContainer_story$data = IllegalContentReportViewContainer_story;
export type IllegalContentReportViewContainer_story$key = {
    readonly " $data"?: IllegalContentReportViewContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"IllegalContentReportViewContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IllegalContentReportViewContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '8def121c7395bf1b7a04af7305a58de4';
export default node;
